import { Suspense, useLayoutEffect } from "react";

import { AbilityContext } from "@context/can";
import { BrowserRouter } from "react-router-dom";
import { ComponentSpinner } from "@components/spinner";
import ErrorBoundary from "../error-boundary";
// ** Router Import
import Router from "./router";
import { ThemeProvider } from "@context/theme";
import { UserProvider } from "./utility/context/user";
import ability from "./configs/acl/ability";

const App = () => {
    const clearCaches = async () => {
        const cacheKeys = await caches.keys();
        cacheKeys.forEach(async key => {
            await caches.delete(key);
        });
    };

    useLayoutEffect(() => {
        window.scroll(0, 0);
        clearCaches();
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <ThemeProvider>
                    <Suspense fallback={<ComponentSpinner />}>
                        <AbilityContext.Provider value={ability}>
                            <UserProvider>
                                <Router />
                            </UserProvider>
                        </AbilityContext.Provider>
                    </Suspense>
                </ThemeProvider>
            </BrowserRouter>
        </ErrorBoundary>
    );
};

export default App;
